var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreaterThan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96708 8.16119C9.98064 8.11317 9.9875 8.06252 9.98662 8.01046C9.98662 8.01046 9.98662 8.01045 9.98662 8.01045L9.48669 8.01892C9.48392 7.85472 9.41218 7.67821 9.2715 7.54181L2.81308 1.28026C2.52604 1.00197 2.08113 1.00197 1.79409 1.28026C1.50704 1.55855 1.50704 1.9899 1.79409 2.26819L6.25475 6.59288C7.06521 7.37863 7.06521 8.67899 6.25475 9.46474L1.77973 13.8033C1.49269 14.0816 1.49269 14.513 1.77973 14.7913C2.06677 15.0696 2.51169 15.0696 2.79873 14.7913L9.96708 8.16119ZM9.96708 8.16119C9.9553 8.28157 9.92432 8.39945 9.87525 8.51047C9.81074 8.65639 9.71661 8.7868 9.59955 8.89419L9.96708 8.16119Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThan);
export default __webpack_public_path__ + "static/media/greater-than.0815cb456b98110ae1214c73f29c3b3e.svg";
export { ForwardRef as ReactComponent };